import { combineReducers } from 'redux';
import authReducer from './Reducers/authReducers';


const rootReducer = combineReducers({
        auth : authReducer
});

export default rootReducer;